var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var Long = require('long');

var _require = require('sha3'),
    SHA3 = _require.SHA3;

var Codec =
/*#__PURE__*/
function () {
  "use strict";

  function Codec() {
    _classCallCheck(this, Codec);

    this._buf = Buffer.alloc(0);
  }

  _createClass(Codec, [{
    key: "pushInt",
    value: function pushInt(len) {
      var bb = Buffer.alloc(4);
      bb.writeInt32BE(len, 0);
      this._buf = Buffer.concat([this._buf, bb]);
      return this;
    }
  }, {
    key: "pushByte",
    value: function pushByte(n) {
      var bb = Buffer.alloc(1);
      bb.writeUInt8(n, 0);
      this._buf = Buffer.concat([this._buf, bb]);
      return this;
    }
  }, {
    key: "pushInt64",
    value: function pushInt64(n) {
      var l = Long.fromString(n + "");
      var bb = Buffer.alloc(8);
      bb.writeInt32BE(l.high, 0);
      bb.writeInt32BE(l.low, 4);
      this._buf = Buffer.concat([this._buf, bb]);
      return this;
    }
  }, {
    key: "pushString",
    value: function pushString(s) {
      var len = s.length;
      var bb = Buffer.from(s);
      this.pushInt(bb.length);
      this._buf = Buffer.concat([this._buf, bb]);
      return this;
    }
  }, {
    key: "pushBytes",
    value: function pushBytes(b) {
      this.pushInt(b.length);
      this._buf = Buffer.concat([this._buf, b]);
      return this;
    }
  }]);

  return Codec;
}();

module.exports = Codec;